module.exports = __webpack_public_path__ + "img/BoD_05_Mr_Daniel_Soh.014d53b1.jpg";